"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montagnareale": {
    "16cd9663": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "cascio": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "571f2ff3": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "casitti": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aaa25c95": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "filanda": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2b80055": [{
      "hkey": "6375a2f1",
      "slug": "fiumara-fiumara-serro",
      "name": "Fiumara-Fiumara Serro",
      "primary": true,
      "skipSearch": false
    }],
    "fiumara-alta": [{
      "hkey": "6375a2f1",
      "slug": "fiumara-fiumara-serro",
      "name": "Fiumara-Fiumara Serro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montagnareale"
    }],
    "b72c7293": [{
      "hkey": "6375a2f1",
      "slug": "fiumara-fiumara-serro",
      "name": "Fiumara-Fiumara Serro",
      "primary": true,
      "skipSearch": false
    }],
    "fiumara-bassa": [{
      "hkey": "6375a2f1",
      "slug": "fiumara-fiumara-serro",
      "name": "Fiumara-Fiumara Serro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montagnareale"
    }],
    "f50097e0": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "piano-annunziata": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5934cfc2": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "pietra-bianca": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93e04768": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "pietre-rosse": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d73f8554": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "piraino": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9829d3c": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "santo-pietro": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e603c00c": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "spirini": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69b3579a": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "skipSearch": false
    }],
    "valanche": [{
      "hkey": "01c26de8",
      "slug": "montagnareale",
      "name": "Montagnareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;